import { View } from "react-native";
import { FirebaseFirestoreTypes } from "@react-native-firebase/firestore";
import { ImageSize } from "./MarkCracks";
import { crackMarkStyles } from "./CrackMark";

type Props = {
  crackMarking: FirebaseFirestoreTypes.QueryDocumentSnapshot<FirebaseFirestoreTypes.DocumentData>;
  imageSize?: ImageSize;
};

export default function DisplayCrackMark({ crackMarking, imageSize }: Props) {
  const { x, y, size } = crackMarking.data();

  if (!imageSize) {
    return null;
  }

  const { width, height } = imageSize!;

  const absoluteSize = (size / 100) * width;

  // The same mark is drawn on the small list previews and on the full-size
  // detail photo, so the ring scales with how wide the photo actually renders:
  // 3px on the preview tiles, the original 5px from ~350pt upwards.
  const borderWidth = Math.min(5, Math.max(3, Math.round(width / 75)));

  const dynamicStyle = {
    left: -absoluteSize / 2,
    top: -absoluteSize / 2,
    height: absoluteSize,
    width: absoluteSize,
    borderWidth,
    transform: [
      { translateX: (x / 100) * width },
      { translateY: (y / 100) * height },
    ],
  };

  return <View style={[crackMarkStyles.crackMarkPosition, dynamicStyle]} />;
}
